import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useHistory, useLocation } from 'react-router-dom';

import { Button } from '@betareader/design-system';
import Icon from '../../../components/AppIcon';
import { useTranslation } from 'react-i18next';

import { authUtil } from '../../../utils';
import { getFollowStatus, toggleFollowStatus } from '../../../modules/book';
import './bookFollowButton.css';

const BookFollowButton = () => {
  const { t } = useTranslation();
  const currentBook = useSelector(state => state.book.currentBook);
  const followStatus = useSelector(state => state.book.followStatus);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    setup();
  }, [currentBook]);

  const setup = async () => {
    const idToken = await authUtil.getFreshIdToken();
    if (!currentBook) {
      return;
    }
    dispatch(getFollowStatus({ idToken, bookId: currentBook._id }));
  };

  const toggleFollowBook = async action => {
    const idToken = await authUtil.getFreshIdToken();
    if (!idToken) {
      // get the user signed in
      goToSignIn();
      return;
    }
    if (action) {
      dispatch(
        toggleFollowStatus({ idToken, bookId: currentBook._id, action })
      );
      return;
    }
    // no action provided, just toggle status
    if (
      followStatus[currentBook._id] &&
      followStatus[currentBook._id].following
    ) {
      dispatch(
        toggleFollowStatus({
          idToken,
          bookId: currentBook._id,
          action: 'unfollow',
        })
      );
    } else {
      dispatch(
        toggleFollowStatus({
          idToken,
          bookId: currentBook._id,
          action: 'follow',
        })
      );
    }
  };

  const goToSignIn = () => {
    history.push(
      `/signin?redirect=${encodeURIComponent(
        location.pathname + location.search
      )}`
    );
  };

  // rendering
  if (!currentBook) {
    return null;
  }

  const status = followStatus[currentBook._id];
  const isFollowing = Boolean(status?.following);
  const followerCount = status?.followers || 0;

  return (
    <Button
      variant="secondary"
      size="small"
      aria-pressed={isFollowing}
      aria-label={`${isFollowing ? t('Following') : t('Follow')} · ${followerCount} ${t('Followers')}`}
      onClick={() => toggleFollowBook()}
      style={{ marginLeft: 'auto' }}
    >
        <span>
          <Icon name="feed" />
          <span className="br-follow-button__text">
            {isFollowing ? t('Following') : t('Follow')}
          </span>
          <span
            style={{ margin: '5px 5px 5px 5px' }}
          >
            ·
          </span>
          <span>{followerCount}</span>
        </span>
    </Button>
  );
};

export default BookFollowButton;
